import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * PrefOnlySelectState
 */
export interface PrefOnlySelectState {
  prefOnlySelectJobCount: number;
  prefName: string | null;
  prefOnlyFlg: boolean;
}

export const prefOnlySelectInitialState: PrefOnlySelectState = {
  prefOnlySelectJobCount: 0,
  prefName: null,
  prefOnlyFlg: false,
};

export const prefOnlySelectSlice = createSlice({
  name: 'prefOnlySelect',
  initialState: prefOnlySelectInitialState,
  reducers: {
    setPrefOnlySelectJobCount: (state, action) => {
      state.prefOnlySelectJobCount = action.payload;
    },
    setPrefName: (
      state,
      action: PayloadAction<PrefOnlySelectState['prefName']>
    ) => {
      state.prefName = action.payload;
    },
    setIsPrefOnlyFlg: (state, action) => {
      state.prefOnlyFlg = action.payload;
    },
  },
});

// Create Action
export const { setPrefOnlySelectJobCount, setPrefName, setIsPrefOnlyFlg } =
  prefOnlySelectSlice.actions;

// Reducer
export const prefOnlySelectReducer = prefOnlySelectSlice.reducer;

interface State {
  prefOnlyFlg: PrefOnlySelectState;
}

// Selector
/**
 * prefOnlySelectJobCountSelector
 * @param state
 */
export const prefOnlySelectJobCountSelector = <S extends State>(state: S) =>
  state.prefOnlyFlg.prefOnlySelectJobCount;

/**
 * prefNameSelector
 * @param state
 */
export const prefNameSelector = <S extends State>(state: S) =>
  state.prefOnlyFlg.prefName;

/**
 * prefOnlyFlgSelector
 * @param state
 */
export const prefOnlyFlgSelector = <S extends State>(state: S) =>
  state.prefOnlyFlg.prefOnlyFlg;
